import { useState, useEffect, useCallback } from "react";
import { getFriends, addFriend, removeFriend } from "../services/friends";
import { useAuth } from "./useAuth";

export function useFriends() {
  const { user } = useAuth();
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFriends = useCallback(async () => {
    if (!user) {
      setFriends([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const friendsList = await getFriends();
      setFriends(friendsList);
      setError(null);
    } catch (err) {
      console.error("Error fetching friends:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchFriends();
  }, [fetchFriends]);

  const addNewFriend = async (email) => {
    try {
      setError(null);
      const newFriend = await addFriend(email);
      setFriends((prev) => [...prev, newFriend]);
      return newFriend;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const deleteFriend = async (friendDocId) => {
    try {
      await removeFriend(friendDocId);
      setFriends((prev) => prev.filter((f) => f.id !== friendDocId));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  return {
    friends,
    loading,
    error,
    addFriend: addNewFriend,
    removeFriend: deleteFriend,
    refresh: fetchFriends,
  };
}
